import incomeDetail from "@/view/account/incomeDetail"
import withdraw from "@/view/account/withdraw"
import equipment from "@/view/data/equipment/equipment"
import equipmentIndex from "@/view/data/equipment/index"
import marketingDaily2 from "@/view/data/equipment/marketingDaily"
import onlyEquipment from "@/view/data/equipment/onlyEquipment"
import onlyProduct from "@/view/data/equipment/onlyProduct"
import rankList2 from "@/view/data/equipment/rankList"
import productIndex from "@/view/data/product/index"
import marketingDaily from "@/view/data/product/marketingDaily"
import rankList from "@/view/data/product/rankList"
import equipmentHome from "@/view/equipment/equipmentHome"
import equipmentList from "@/view/equipment/equipmentList"
import equipmentSetting from "@/view/equipment/equipmentSetting"
import equipmentSettingInfo from "@/view/equipment/equipmentSetting-info"
import equipmentOpenList from "@/view/equipment/openLogList"
import equipmentPeel from '@/view/equipment/peel'
import Home from '@/view/Home'
import homeByToolCabinet from '@/view/homeByToolCabinet'
import houseQuarterList from "@/view/locker/houseQuarterList"
import lockerCargoList from "@/view/locker/lockerCargoList"
import lockerHouseDetail from "@/view/locker/lockerHouseDetail"
import lockerHouseList from "@/view/locker/lockerHouseList"
import lockerOrderDetail from "@/view/locker/lockerOrderDetail"
import lockerOrderList from "@/view/locker/lockerOrderList"
import lockerOrderSearchResult from "@/view/locker/lockerOrderSearch"
import lockerOrderSearch from "@/view/locker/search"
import contact from "@/view/My/contact"
import contactSuccess from "@/view/My/contactSuccess"
import userCenter from "@/view/My/index"
import messageList from "@/view/My/messageList"
import noticeDetail from "@/view/My/noticeDetail"
import noticeList from "@/view/My/noticeList"
import roleList from "@/view/My/roleList"
import orderDetail from "@/view/order/orderDetail"
import orderList from "@/view/order/orderList"
import sendOrder from "@/view/order/sendOrder"
import verification from "@/view/order/verification"
import waitFinishOrderList from "@/view/order/waitFinishOrderList"
import waitSendOrderList from "@/view/order/waitSendOrderList"
import pageNone from '@/view/pageNone'
import productList from "@/view/product/productList"
import saveProduct from "@/view/product/saveProduct"
import scanBlank from '@/view/scanBlank'
import chooseAddress from "@/view/shop/chooseAddress"
import shopRegisterBaseInfo from "@/view/shop/register/baseInfo"
import shopRegisterCheckError from "@/view/shop/register/checkError"
import shopRegisterChecking from "@/view/shop/register/checking"
import shopRegisterShopType from "@/view/shop/register/chooseShopType"
import shopRegisterCompanyInfo from "@/view/shop/register/companyInfo"
import shopRegisterContract from "@/view/shop/register/contract"
import shopRegisterShopSetting from "@/view/shop/register/shopSetting"
import shopBankInfo from "@/view/shop/shopSetting/bankInfo"
import shopBaseInfo from "@/view/shop/shopSetting/baseInfo"
import shopInfoIndex from "@/view/shop/shopSetting/index"
import shopQualifyInfo from "@/view/shop/shopSetting/qualifyInfo"
import shopMainInfo from "@/view/shop/shopSetting/shopInfo"
import supplyRecordDetail from "@/view/supplyRecord/detail"
import exchangeProduct from "@/view/supplyRecord/exchangeProduct"
import latticeSupplyCompare from "@/view/supplyRecord/latticeSupplyCompare"
import supplyRecordList from "@/view/supplyRecord/list"
import springSupplyCompare from "@/view/supplyRecord/springSupplyCompare"
import supplyCompare from "@/view/supplyRecord/supplyCompare"
import Forget from '@/view/User/forget_psd'
import Login from '@/view/User/Login'
import disStockCabinet from "@/view/warning/disStockCabinet"
import disStockCabinetDetail from "@/view/warning/disStockCabinetDetail"
import errorWarning from "@/view/warning/errorWarning"
import overDateDetail from "@/view/warning/overDateDetail"
import overDateList from "@/view/warning/overDateList"
import overDateWarning from "@/view/warning/overDateWarning"
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
  // mode: 'history',

  routes: [
    {
      path: '/',
      name: '/',
      component: Home,
      meta: {
        title: '首页',
        index: 1,
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '登录',
        index: 1,
      }
    },
    {
      path: '/forget',
      name: 'forget',
      component: Forget,
      meta: {
        title: '忘记密码',
        index: 2,
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        title: '首页',
        index: 1,
        keepAlive: true
      }
    },
    {
      path: '/homeByToolCabinet',
      name: 'homeByToolCabinet',
      component: homeByToolCabinet,
      meta: {
        title: '首页',
        index: 1,
        keepAlive: true
      }
    },
    {
      path: '/product/saveProduct',
      name: 'saveProduct',
      component: saveProduct,
      meta: {
        title: '编辑商品',
        index: 3,
      }
    },
    {
      path: '/product/productList',
      name: 'productList',
      component: productList,
      meta: {
        title: '商品列表',
        keepAlive: true,
        index: 2,
      }
    },
    {
      path: '/shop/shopSetting/main',
      name: 'settingMain',
      component: shopInfoIndex,
      meta: {
        title: '店铺设置',
        index: 2,
      }
    },
    {
      path: '/shop/chooseAddress',
      name: 'chooseAddress',
      component: chooseAddress,
      meta: {
        title: '详细地址',
        index: 6,
      }
    },
    {
      path: '/shop/shopSetting/base',
      name: 'shopBaseInfo',
      component: shopBaseInfo,
      meta: {
        title: '基本信息',
        index: 3,
      }
    },
    {
      path: '/shop/shopSetting/bank',
      name: 'shopBankInfo',
      component: shopBankInfo,
      meta: {
        title: '银行信息',
        index: 3,
      }
    },
    {
      path: '/shop/shopSetting/qualify',
      name: 'shopQualifyInfo',
      component: shopQualifyInfo,
      meta: {
        title: '资质信息',
        index: 3,
      }
    },
    {
      path: '/shop/shopSetting/shopMainInfo',
      name: 'shopMainInfo',
      component: shopMainInfo,
      meta: {
        title: '店铺设置',
        index: 3,
      }
    },
    {
      path: '/shop/register/shopType',
      name: 'shopRegisterShopType',
      component: shopRegisterShopType,
      meta: {
        title: '商家入驻',
        index: 2
      }
    },
    {
      path: '/shop/register/contract',
      name: 'shopRegisterContract',
      component: shopRegisterContract,
      meta: {
        title: '商家合约',
        index: 3
      }
    },
    {
      path: '/shop/register/baseInfo',
      name: 'shopRegisterBaseInfo',
      component: shopRegisterBaseInfo,
      meta: {
        title: '商家入驻',
        index: 4
      }
    },
    {
      path: '/shop/register/companyInfo',
      name: 'shopRegisterCompanyInfo',
      component: shopRegisterCompanyInfo,
      meta: {
        title: '商家入驻',
        index: 5
      }
    },
    {
      path: '/shop/register/shopSetting',
      name: 'shopRegisterShopSetting',
      component: shopRegisterShopSetting,
      meta: {
        title: '商家入驻',
        index: 6,
      }
    },
    {
      path: '/shop/register/checking',
      name: 'shopRegisterChecking',
      component: shopRegisterChecking,
      meta: {
        title: '商家入驻',
        index: 7,
      }
    },
    {
      path: '/shop/register/checkError',
      name: 'shopRegisterCheckError',
      component: shopRegisterCheckError,
      meta: {
        title: '商家入驻',
        index: 7,
      }
    },

    {
      path: '/order/orderList',
      name: 'orderList',
      component: orderList,
      meta: {
        title: '订单列表',
        keepAlive: true,
        index: 2,
      }
    },
    {
      path: '/order/waitSendOrderList',
      name: 'waitSendOrderList',
      component: waitSendOrderList,
      meta: {
        title: '待发货订单',
        keepAlive: true,
        index: 2,
      }
    },
    {
      path: '/order/waitFinishOrderList',
      name: 'waitFinishOrderList',
      component: waitFinishOrderList,
      meta: {
        title: '待完成订单',
        keepAlive: true,
        index: 2,
      }
    },
    {
      path: '/order/sendOrder',
      name: 'sendOrder',
      component: sendOrder,
      meta: {
        title: '发货',
        index: 3,
      }
    },
    {
      path: '/order/orderDetail',
      name: 'orderDetail',
      component: orderDetail,
      meta: {
        title: '订单详情',
        index: 2,
      }
    },
    {
      path: '/order/verification',
      name: 'verification',
      component: verification,
      meta: {
        title: '核销',
        index: 3,
      }
    },
    {
      path: '/my/userCenter',
      name: 'userCenter',
      component: userCenter,
      meta: {
        title: '个人中心',
        index: 2,
      }
    },
    {
      path: '/my/roleList',
      name: 'roleList',
      component: roleList,
      meta: {
        title: '选择角色',
        index: 3,
      }
    },
    {
      path: '/my/contact',
      name: 'contact',
      component: contact,
      meta: {
        title: '联系客服',
        index: 2,
      }
    },
    {
      path: '/my/contactSuccess',
      name: 'contactSuccess',
      component: contactSuccess,
      meta: {
        title: '联系客服',
        index: 3,
      }
    },
    {
      path: '/my/noticeList',
      name: 'noticeList',
      component: noticeList,
      meta: {
        title: '通知',
        keepAlive: true,
        index: 2,
      }
    },
    {
      path: '/my/noticeDetail',
      name: 'noticeDetail',
      component: noticeDetail,
      meta: {
        title: '通知',
        index: 3,
      }
    },
    {
      path: '/my/messageList',
      name: 'messageList',
      component: messageList,
      meta: {
        title: '消息',
        index: 2,
      }
    },
    {
      path: '/account/incomeDetail',
      name: 'incomeDetail',
      component: incomeDetail,
      meta: {
        title: '收入明细',
        index: 2,
      }
    },
    {
      path: '/account/withdraw',
      name: 'withdraw',
      component: withdraw,
      meta: {
        title: '提现',
        index: 3,
      }
    },
    {
      path: '/scanBlank',
      name: 'scanBlank',
      component: scanBlank,
      meta: {
        title: '扫描结果',
        index: 3,
      }
    },

    /* -------数据端商品页面---------*/
    {
      path: '/data/product/marketingDaily',
      name: 'marketingDaily',
      component: marketingDaily,
      meta: {
        title: '营销日报',
      },
    },

    {
      path: '/data/product/rankList',
      name: 'rankList',
      component: rankList,
      meta: {
        title: '排行榜',
      },
    },

    {
      path: '/data/product/index',
      name: 'productIndex',
      component: productIndex,
      meta: {
        title: '',
      },
    },

    /* -------数据端设备页面---------*/
    {
      path: '/data/equipment/marketingDaily',
      name: 'marketingDaily2',
      component: marketingDaily2,
      meta: {
        title: '概况',
      },
    },

    {
      path: '/data/equipment/rankList',
      name: 'rankList2',
      component: rankList2,
      meta: {
        title: '排行',
      },
    },

    {
      path: '/data/equipment/equipment',
      name: 'equipment',
      component: equipment,
      meta: {
        title: '设备',
      },
    },

    {
      path: '/data/equipment/index',
      name: 'equipmentIndex',
      component: equipmentIndex,
      meta: {
        title: '',
      },
    },

    {
      path: '/data/equipment/onlyProduct',
      name: 'onlyProduct',
      component: onlyProduct,
      meta: {
        title: '商品',
      },
    },

    {
      path: '/data/equipment/onlyEquipment',
      name: 'onlyEquipment',
      component: onlyEquipment,
      meta: {
        title: '设备',
      },
    },


    {
      path: '/warning/overDateWarning',
      name: 'overDateWarning',
      component: overDateWarning,
      meta: {
        title: '过期预警',
        index: 2,
        keepAlive: true,
      }
    },
    {
      path: '/warning/overDateDetail',
      name: 'overDateDetail',
      component: overDateDetail,
      meta: {
        title: '过期预警',
        index: 3,
      }
    },
    {
      path: '/warning/overDateList',
      name: 'overDateList',
      component: overDateList,
      meta: {
        title: '已过期',
        index: 2,
        keepAlive: true,
      }
    },
    {
      path: '/warning/errorWarning',
      name: 'errorWarning',
      component: errorWarning,
      meta: {
        title: '异常预警',
        index: 3,
      }
    },
    {
      path: '/warning/disStockCabinet',
      name: 'disStockCabinet',
      component: disStockCabinet,
      meta: {
        title: '缺货柜子',
        index: 2,
        keepAlive: true,
      }
    },
    {
      path: '/warning/disStockCabinetDetail',
      name: 'disStockCabinetDetail',
      component: disStockCabinetDetail,
      meta: {
        title: '缺货详情',
        index: 3,
      }
    },
    {
      path: '/supplyRecord/supplyCompare',
      name: 'supplyCompare',
      component: supplyCompare,
      meta: {
        title: '货道对照单',
        index: 2,
      }
    },
    {
      path: '/supply/latticeSupplyCompare',
      name: 'latticeSupplyCompare',
      component: latticeSupplyCompare,
      meta: {
        title: '补货',
        index: 2,
      }
    },
    {
      path: '/supply/springSupplyCompare',
      name: 'springSupplyCompare',
      component: springSupplyCompare,
      meta: {
        title: '补货',
        index: 2,
      }
    },
    {
      path: '/supply/exchangeProduct',
      name: 'exchangeProduct',
      component: exchangeProduct,
      meta: {
        title: '换绑商品',
        index: 3,
      }
    },

    {
      path: '/supplyRecord/list',
      name: 'supplyRecordList',
      component: supplyRecordList,
      meta: {
        title: '取货/补货记录',
        index: 4,
        keepAlive: true,
      }
    },
    {
      path: '/supplyRecord/detail',
      name: 'supplyRecordDetail',
      component: supplyRecordDetail,
      meta: {
        title: '记录详情',
        index: 5,
      }
    },
    {
      path: '/scanBlank',
      name: 'scanBlank',
      component: scanBlank,
      meta: {
        title: '扫描结果',
        index: 3,
      }
    },



    {
      path: '/locker/lockerHouseList',
      name: 'lockerHouseList',
      component: lockerHouseList,
      meta: {
        title: '寄存详情',
        index: 2,
        keepAlive: true,
      }
    },

    {
      path: '/locker/lockerHouseDetail',
      name: 'lockerHouseDetail',
      component: lockerHouseDetail,
      meta: {
        title: '小区寄存详情',
        index: 3,
        // keepAlive:true,
      }
    },
    {
      path: '/locker/lockerOrderList',
      name: 'lockerOrderList',
      component: lockerOrderList,
      meta: {
        title: '寄存柜订单',
        index: 3,
      }
    },
    {
      path: '/locker/lockerOrderDetail',
      name: 'lockerOrderDetail',
      component: lockerOrderDetail,
      meta: {
        title: '货道详情',
        index: 4,
        // keepAlive:true,
      }
    },
    {
      path: '/locker/lockerCargoList',
      name: 'lockerCargoList',
      component: lockerCargoList,
      meta: {
        title: '寄存柜货道列表',
        index: 2,
        // keepAlive:true,
      }
    },
    {
      path: '/locker/houseQuarterList',
      name: 'houseQuarterList',
      component: houseQuarterList,
      meta: {
        title: '选择小区',
        index: 4,
        // keepAlive:true,
      }
    },
    {
      path: '/locker/Search',
      name: 'lockerOrderSearch',
      component: lockerOrderSearch,
      meta: {
        title: '搜索',
        index: 4,
        // keepAlive:true,
      }
    },

    {
      path: '/locker/lockerOrderSearch',
      name: 'lockerOrderSearchResult',
      component: lockerOrderSearchResult,
      meta: {
        title: '搜索',
        index: 5,
        // keepAlive:true,
      }
    },

    {
      path: '/equipment/list',
      name: 'equipmentList',
      component: equipmentList,
      meta: {
        title: '我的柜子',
        index: 2,
        keepAlive: true,
      }
    },
    {
      path: '/equipment/home',
      name: 'equipmentHome',
      component: equipmentHome,
      meta: {
        title: '概况',
        index: 3,
      }
    },
    {
      path: '/equipment/openLogList',
      name: 'equipmentOpenList',
      component: equipmentOpenList,
      meta: {
        title: '开门',
        index: 3,
        keepAlive: true,
      }
    },
    {
      path: '/equipment/setting',
      name: 'equipmentSetting',
      component: equipmentSetting,
      meta: {
        title: '设置',
        index: 3,
      }
    },
    {
      path: '/equipment/peel',
      name: 'equipmentPeel',
      component: equipmentPeel,
      meta: {
        title: '去皮',
        index: 4,
      }
    },
    {
      path: '/equipment/settingInfo',
      name: 'equipmentSettingInfo',
      component: equipmentSettingInfo,
      meta: {
        title: '设置',
        index: 5,
      }
    },
    {
      path: '*',
      name: '404',
      component: pageNone,
      meta: {
        title: '404',
        index: 10,
      }
    },
    {
      path: '/scm/settingInfo',
      name: 'equipmentSettingInfo',
      component: equipmentSettingInfo,
      meta: {
        title: '设置',
        index: 5,
      }
    },
    {
      path: '/scm/planShopApplyList',
      name: 'planShopApplyList',
      component: () => import('@/view/scm/planShopApplyList.vue'),
      meta: {
        title: '补货申请列表',
        index: 5,
      }
    },
    {
      path: '/scm/planShopApplyAdd',
      name: 'planShopApplyAdd',
      component: () => import('@/view/scm/planShopApplyAdd.vue'),
      meta: {
        title: '补货申请',
        index: 5,
      }
    },
    {
      path: '/scm/planShopApplyInfo',
      name: 'planShopApplyInfo',
      component: () => import('@/view/scm/planShopApplyInfo.vue'),
      meta: {
        title: '补货申请明细',
        index: 5,
      }
    },
    {
      path: '/shop/shopSaleDataList',
      name: 'shopSaleDataList',
      component: () => import('@/view/shop/shopSaleData/shopSaleDataList.vue'),
      meta: {
        title: '销售数据',
        index: 5,
      }
    },
    {
      path: '/shop/shopSaleDataAdd',
      name: 'shopSaleDataAdd',
      component: () => import('@/view/shop/shopSaleData/shopSaleDataAdd.vue'),
      meta: {
        title: '数据上传',
        index: 5,
      }
    },
    {
      path: '/scm/orgReplenishList',
      name: 'orgReplenishList',
      component: () => import('@/view/scm/orgReplenishList.vue'),
      meta: {
        title: '补货发货',
        index: 5,
      }
    },
    {
      path: '/scm/orgReplenishInfo',
      name: 'orgReplenishInfo',
      component: () => import('@/view/scm/orgReplenishInfo.vue'),
      meta: {
        title: '补货明细',
        index: 5,
      }
    },
    {
      path: '/scm/WareReceiptCheck',
      name: 'WareReceiptCheck',
      component: () => import('@/view/scm/WareReceiptCheck.vue'),
      meta: {
        title: '收货管理',
        index: 7,
      }
    },
    {
      path: '/scm/WareArrivalAppoin',
      name: 'WareArrivalAppoin',
      component: () => import('@/view/scm/WareArrivalAppoin.vue'),
      meta: {
        title: '新增收货',
        index: 7,
      }
    },
    {
      path: '/scm/WareReceiptCheckDetail',
      name: 'WareReceiptCheckDetail',
      component: () => import('@/view/scm/WareReceiptCheckDetail.vue'),
      meta: {
        title: '收货明细',
        index: 7,
      }
    },
    {
      path: '/scm/WareReceiptCheckToCheck',
      name: 'WareReceiptCheckToCheck',
      component: () => import('@/view/scm/WareReceiptCheckToCheck.vue'),
      meta: {
        title: '收货验收',
        index: 7,
      }
    },
    {
      path: '/scm/stockInfo',
      name: 'stockInfo',
      component: () => import('@/view/scm/stockInfo.vue'),
      meta: {
        title: '库存查询',
        index: 7,
      }
    },
    {
      path: '/scm/stockOp',
      name: 'stockOp',
      component: () => import('@/view/scm/stockOp.vue'),
      meta: {
        title: '库存上下架',
        index: 7,
      }
    },
    {
      path: '/scm/WareProdSorting',
      name: 'WareProdSorting',
      component: () => import('@/view/scm/WareProdSorting.vue'),
      meta: {
        title: '拣货单',
        index: 7,
      }
    },
    {
      path: '/scm/WareProdSortingDetail',
      name: 'WareProdSortingDetail',
      component: () => import('@/view/scm/WareProdSortingDetail.vue'),
      meta: {
        title: '拣货单明细',
        index: 7,
      }
    },
    {
      path: '/scm/WareProdSortingAdd',
      name: 'WareProdSortingAdd',
      component: () => import('@/view/scm/WareProdSortingAdd.vue'),
      meta: {
        title: '生成拣货单',
        index: 7,
      }
    },
    {
      path: '/scm/WareDeliverSorting',
      name: 'WareDeliverSorting',
      component: () => import('@/view/scm/WareDeliverSorting.vue'),
      meta: {
        title: '配送分拣',
        index: 7,
      }
    },
    {
      path: '/scm/WareDeliverSortingDetail',
      name: 'WareDeliverSortingDetail',
      component: () => import('@/view/scm/WareDeliverSortingDetail.vue'),
      meta: {
        title: '配送分拣明细',
        index: 7,
      }
    },
    {
      path: '/scm/WareDeliverSortingBind',
      name: 'WareDeliverSortingBind',
      component: () => import('@/view/scm/WareDeliverSortingBind.vue'),
      meta: {
        title: '配送容器绑定',
        index: 7,
      }
    },
    {
      path: '/scm/wareStoreReturnApply',
      name: 'wareStoreReturnApply',
      component: () => import('@/view/scm/wareStoreReturnApply.vue'),
      meta: {
        title: '退回申请列表',
        index: 7,
      }
    },
    {
      path: '/scm/wareStoreReturnApplyAdd',
      name: 'wareStoreReturnApplyAdd',
      component: () => import('@/view/scm/wareStoreReturnApplyAdd.vue'),
      meta: {
        title: '退回申请',
        index: 7,
      }
    },
    {
      path: '/scm/wareStoreReturnApplyDetail',
      name: 'wareStoreReturnApplyDetail',
      component: () => import('@/view/scm/wareStoreReturnApplyDetail.vue'),
      meta: {
        title: '退回申请明细',
        index: 7,
      }
    },
    {
      path: '/scm/WareStocktaking',
      name: 'WareStocktaking',
      component: () => import('@/view/scm/WareStocktaking.vue'),
      meta: {
        title: '库存盘点列表',
        index: 7,
      }
    },
    {
      path: '/scm/WareStocktakingDo',
      name: 'WareStocktakingDo',
      component: () => import('@/view/scm/WareStocktakingDo.vue'),
      meta: {
        title: '库存盘点',
        index: 7,
      }
    },
    {
      path: '/scm/WareStocktakingDetail',
      name: 'WareStocktakingDetail',
      component: () => import('@/view/scm/WareStocktakingDetail.vue'),
      meta: {
        title: '库存盘点明细',
        index: 7,
      }
    },
    {
      path: '/scm/WareDeliverSortingListForD',
      name: 'WareDeliverSortingListForD',
      component: () => import('@/view/scm/WareDeliverSortingListForD.vue'),
      meta: {
        title: '司机配送',
        index: 7,
      }
    },
    {
      path: '/scm/WareProdSortingOneClickTake',
      name: 'WareProdSortingOneClickTake',
      component: () => import('@/view/scm/WareProdSortingOneClickTake.vue'),
      meta: {
        title: '一键接货',
        index: 7,
      }
    },
    {
      path: '/scm/WareDeliverSortingTake',
      name: 'WareDeliverSortingTake',
      component: () => import('@/view/scm/WareDeliverSortingTake.vue'),
      meta: {
        title: '到货签收',
        index: 7,
      }
    },
    {
      path: '/scm/WareDeliverSortingSign',
      name: 'WareDeliverSortingSign',
      component: () => import('@/view/scm/WareDeliverSortingSign.vue'),
      meta: {
        title: '到货签收',
        index: 7,
      }
    },
    {
      path: '/scm/WareDeliverSortingListForR',
      name: 'WareDeliverSortingListForR',
      component: () => import('@/view/scm/WareDeliverSortingListForR.vue'),
      meta: {
        title: '到货签收',
        index: 7,
      }
    },
    {
      path: '/scm/WareDeliverSortingListForROrg',
      name: 'WareDeliverSortingListForROrg',
      component: () => import('@/view/scm/WareDeliverSortingListForROrg.vue'),
      meta: {
        title: '到货签收',
        index: 7,
      }
    },
    {
      path: '/scm/WareReceiptCheckToCheckDo',
      name: 'WareReceiptCheckToCheckDo',
      component: () => import('@/view/scm/WareReceiptCheckToCheckDo.vue'),
      meta: {
        title: '收货验收',
        index: 7,
      }
    },
    {
      path: '/scm/WareProdTransfer',
      name: 'WareProdTransfer',
      component: () => import('@/view/scm/WareProdTransfer.vue'),
      meta: {
        title: '库存调拨',
        index: 7,
      }
    },
    {
      path: '/scm/WareProdTransferAdd',
      name: 'WareProdTransferAdd',
      component: () => import('@/view/scm/WareProdTransferAdd.vue'),
      meta: {
        title: '申请调拨',
        index: 7,
      }
    },
    {
      path: '/scm/WareProdTransferDetail',
      name: 'WareProdTransferDetail',
      component: () => import('@/view/scm/WareProdTransferDetail.vue'),
      meta: {
        title: '调拨明细',
        index: 7,
      }
    },
    {
      path: '/equipment/equipmentStock',
      name: 'equipmentStock',
      component: () => import('@/view/equipment/equipmentStock'),
      meta: {
        title: '库存明细',
        index: 7,
      }
    },
    {
      path: '/scm/stockProduce',
      name: 'stockProduce',
      component: () => import('@/view/scm/stockProduce'),
      meta: {
        title: '库存生产',
        index: 7,
      }
    },
    {
      path: '/scm/stockProduceAdd',
      name: 'stockProduceAdd',
      component: () => import('@/view/scm/stockProduceAdd'),
      meta: {
        title: '库存生产',
        index: 7,
      }
    },
    {
      path: '/scm/stockProduceTake',
      name: 'stockProduceTake',
      component: () => import('@/view/scm/stockProduceTake'),
      meta: {
        title: '生产领料',
        index: 7,
      }
    },
    {
      path: '/scm/wareReceiptCheckReceiptOrg',
      name: 'wareReceiptCheckReceiptOrg',
      component: () => import('@/view/scm/wareReceiptCheckReceiptOrg'),
      meta: {
        title: '采购收货',
        index: 7,
      }
    },
    {
      path: '/equipment/localPos',
      name: 'localPos',
      component: () => import('@/view/equipment/localPos'),
      meta: {
        title: '收银',
        index: 7,
      }
    },
    {
      path: '/equipment/equStocktaking',
      name: 'equStocktaking',
      component: () => import('@/view/equipment/equStocktaking'),
      meta: {
        title: '柜子盘点',
        index: 7,
      }
    },
    {
      path: '/equipment/equStocktakingDo',
      name: 'equStocktakingDo',
      component: () => import('@/view/equipment/equStocktakingDo.vue'),
      meta: {
        title: '柜子盘点',
        index: 7,
      }
    },
    {
      path: '/equipment/equStocktakingDetail',
      name: 'equStocktakingDetail',
      component: () => import('@/view/equipment/equStocktakingDetail.vue'),
      meta: {
        title: '柜子盘点明细',
        index: 7,
      }
    },
    {
      path: '/equipment/shopStocktaking',
      name: 'shopStocktaking',
      component: () => import('@/view/equipment/shopStocktaking'),
      meta: {
        title: '活动店铺盘点',
        index: 7,
        keepAlive: true,
      }
    },
    {
      path: '/equipment/shopStocktakingDo',
      name: 'shopStocktakingDo',
      component: () => import('@/view/equipment/shopStocktakingDo.vue'),
      meta: {
        title: '活动店铺盘点',
        index: 7,
      }
    },
    {
      path: '/equipment/shopStocktakingDetail',
      name: 'shopStocktakingDetail',
      component: () => import('@/view/equipment/shopStocktakingDetail.vue'),
      meta: {
        title: '活动店铺盘点明细',
        index: 7,
      }
    },
    {
      path: '/order/posOrderList',
      name: 'posOrderList',
      component: () => import('@/view/order/posOrderList'),
      meta: {
        title: '活动订单',
        index: 7,
      }
    },
    {
      path: '/scm/stockProduceDetail',
      name: 'stockProduceDetail',
      component: () => import('@/view/scm/stockProduceDetail'),
      meta: {
        title: '生产单明细',
        index: 7,
      }
    },
    {
      path: '/scm/WareVolCodeFree',
      name: 'WareVolCodeFree',
      component: () => import('@/view/scm/WareVolCodeFree'),
      meta: {
        title: '释放容器码',
        index: 7,
      }
    },

  ],

  // scrollBehavior (to, from, savedPosition) {
  //     return { x: 0, y: 0 }
  // }

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js